export const ACTIVATE_CAFE = 'ACTIVATE_CAFE'
export const ACTIVATE_CUSTOM_NAVIGATION = 'ACTIVATE_CUSTOM_NAVIGATION'
export const CLEAR_STORE = 'CLEAR_STORE';
export const DELETE_ENTITY = 'DELETE_ENTITY'
export const DELETE_STORED_DOCUMENT = 'DELETE_STORED_DOCUMENT'
export const DELETE_LOOKUP_SUGGESTION = 'DELETE_LOOKUP_SUGGESTION'
export const REQUEST_DELETE_STORED_DOCUMENT = 'REQUEST_DELETE_STORED_DOCUMENT'
export const REQUEST_DELETE_FILE_FROM_DOC = 'REQUEST_DELETE_FILE_FROM_DOC'
export const REQUEST_RESET_CUSTOMER_DATA = 'REQUEST_RESET_CUSTOMER_DATA'
export const REQUEST_SAVE_DATA_TO_LOCALSTORE = 'REQUEST_SAVE_DATA_TO_LOCALSTORE'
export const REQUEST_SEND_ACTIVATION_EMAIL = 'REQUEST_SEND_ACTIVATION_EMAIL'
export const REQUEST_GET_PERSONALIZATION = 'REQUEST_GET_PERSONALIZATION'
export const REQUEST_GET_SETTINGS = 'REQUEST_GET_SETTINGS'
export const REQUEST_CHECK_ACTIVATION_DATA = 'REQUEST_CHECK_ACTIVATION_DATA'
export const REQUEST_CHECK_PHASE = 'REQUEST_CHECK_PHASE'
export const REQUEST_ACTIVATION = 'REQUEST_ACTIVATION'
export const REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION = 'REQUEST_SEND_DOC_FOR_MANUAL_VALIDATION'
export const REQUEST_SEND_DOC_TO_SERVICE = 'REQUEST_SEND_DOC_TO_SERVICE'
export const REQUEST_SEND_DATA_PREAPPROVAL = 'REQUEST_SEND_DATA_PREAPPROVAL'
export const REQUEST_INIT_REQUEST = 'REQUEST_INIT_REQUEST'
export const REQUEST_INIT_PREAPPROVAL = 'REQUEST_INIT_PREAPPROVAL'
export const REQUEST_STORE_DOCUMENT = 'REQUEST_STORE_DOCUMENT'
export const SAVE_DOCUMENT = 'SAVE_DOCUMENT'
export const RESET_ACTIVATION = 'RESET_ACTIVATION'
export const SET_CAFE_STATUS = 'SET_CAFE_STATUS'
export const SET_COMPANY_LOOKUP_STRUCTURE = 'SET_COMPANY_LOOKUP_STRUCTURE'
export const REQUEST_DOCUMENTS = 'REQUEST_DOCUMENTS'
export const REQUEST_CUSTOM_FIELDS = 'REQUEST_CUSTOM_FIELDS'
export const SET_CUSTOM_FIELDS = 'SET_CUSTOM_FIELDS'
export const SET_CP_FIELDS = 'SET_CP_FIELDS'
export const SET_CP_CATEGORIES = 'SET_CONNECTED_PARTY_CATEGORIES'
export const SET_SUPPORTED_COUNTRIES = 'SET_SUPPORTED_COUNTRIES'
export const SET_SUPPORTED_REGIONS = 'SET_SUPPORTED_REGIONS'
export const SET_CLIENT_EMAIL = 'SET_CLIENT_EMAIL'
export const SET_DOCUMENT_RETRIES = 'SET_DOCUMENT_RETRIES'
export const SET_INIT_APP = 'SET_INIT_APP'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SET_ONBOARDING_TYPE = 'SET_ONBOARDING_TYPE'
export const REQUEST_BACKUP_PARTY = 'REQUEST_BACKUP_PARTY'
export const SET_BACKUP_PARTY = 'SET_BACKUP_PARTY'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_STEP_INDEX = 'SET_STEP_INDEX'
export const SET_TOKEN_VERIFICATION = 'SET_TOKEN_VERIFICATION'
export const SET_TERMS_ACCEPTANCE = 'SET_TERMS_ACCEPTANCE'
export const SET_OWNERS_WARNING_MIN_DOC = 'SET_OWNERS_WARNING_MIN_DOC'
export const SET_STEP_HAS_ERROR = 'SET_STEP_HAS_ERROR'
export const STORE_DOCUMENT = 'STORE_DOCUMENT'
export const STORE_DOCUMENTS = 'STORE_DOCUMENTS'
export const STORE_PARTY_DATA = 'STORE_PARTY_DATA'
export const STORE_OWNER = 'STORE_OWNER'
export const UPDATE_OWNERS = 'UPDATE_OWNERS'
export const SET_STEPS_LIST = 'SET_STEPS_LIST'
export const SET_PHASE_TYPE = 'SET_PHASE_TYPE'
export const SET_IS_REQUEST = 'SET_IS_REQUEST'
//TODO: is this being used? REQUEST_REQUESTED_ENTITY
export const REQUEST_REQUESTED_ENTITY = 'REQUEST_REQUESTED_ENTITY'
export const REQUEST_UPLOAD_ENTITY_DOC = 'REQUEST_UPLOAD_ENTITY_DOC'
export const REQUEST_INSERT_OWNER = 'REQUEST_INSERT_OWNER'
export const REQUEST_UPDATE_OWNER = 'REQUEST_UPDATE_OWNER'
export const REQUEST_DELETE_OWNER = 'REQUEST_DELETE_OWNER'
export const REQUEST_OWNERS = 'REQUEST_OWNERS'
export const SET_OWNERS = 'SET_OWNERS'
export const REQUEST_SUBMIT_REQUEST = 'REQUEST_SUBMIT_REQUEST'
export const REQUEST_DATAS_FROM_OWNER_DOCS = 'REQUEST_DATAS_FROM_OWNER_DOCS'
export const SET_CURRENT_OWNER_DOC = 'SET_CURRENT_OWNER_DOC'
export const SET_CURRENT_OWNER_DOCS = 'SET_CURRENT_OWNER_DOCS'
export const SET_CURRENT_OWNER_CATEGORY_REQUEST = 'SET_CURRENT_OWNER_CATEGORY_REQUEST'
export const DELETE_CURRENT_OWNER_DOC = 'DELETE_CURRENT_OWNER_DOC'
export const DELETE_FILES_FROM_CURRENT_OWNER_DOC = 'DELETE_FILES_FROM_CURRENT_OWNER_DOC'
export const DELETE_ALL_CURRENT_DOCS = 'DELETE_ALL_CURRENT_DOCS'
export const REQUEST_UPDATE_REQUESTED_ENTITY = 'REQUEST_UPDATE_REQUESTED_ENTITY'
export const REQUEST_SET_NAVIGATION = 'REQUEST_SET_NAVIGATION'
export const SET_NAVIGATION = 'SET_NAVIGATION'
export const SET_POST_ERRORS = 'SET_POST_ERRORS'
export const DELETE_POST_ERROR = 'DELETE_POST_ERROR'
export const SET_FIELD_CATEGORIES = 'SET_FIELD_CATEGORIES'
export const REQUEST_UPDATE_KYC_TYPE = 'REQUEST_UPDATE_KYC_TYPE'